<template lang="pug">
  .home
</template>

<script>
export default {
  name: 'home'
}
</script>
